// extracted by mini-css-extract-plugin
export default {"groupDiv":"InputGroup_groupDiv__BUY52"};